import z from 'zod';
import {
  AreYouOkResponseDtoResponse,
  AreYouOkResponseSetDtoResponse,
} from '../../generated/openapi/safety-check';

export const setResponse = z.enum(AreYouOkResponseSetDtoResponse);
const pendingResponse = z.enum(AreYouOkResponseDtoResponse);

export const areYouOkPendingResponse = z.object({
  response: pendingResponse,
  pendingUntil: z.coerce.date().optional(),
});

export type AreYouOkPendingResponse = z.infer<typeof areYouOkPendingResponse>;
export type AreYouOkResponseSet = z.infer<typeof setResponse>;
export const AreYouOkResponseSetEnum = setResponse.enum;
export const AreYouOkPendingResponseEnum = pendingResponse.enum;
